<template>
  <div class="payment-status-modal" v-if="props.isVisible">
    <div class="payment-modal-content">
      <button class="close-button" @click="cancel">
        <span>&times;</span>
      </button>

      <div class="icon-container">
        <img
          v-if="!isError"
          src="@/assets/icons/CircleTick.png"
          alt="Success"
          class="status-icon"
        />
        <img
          v-else
          src="@/assets/icons/CircleClose.png"
          alt="Error"
          class="status-icon"
        />
      </div>

      <h3 class="modal-title h3-semibold " :class="{ success: !isError, error: isError }">
        {{ title }}
      </h3>
      <h6 class="modal-subtitle h6-medium ">{{ message }}</h6>
      <p class="modal-desc" v-if="description">{{ description }}</p>

      <button
        v-if="isError"
        class="primary-btn"
        @click="confirm"
      >
        Try again
      </button>

      <a
        v-if="!isError"
        class="link-btn"
        @click="confirm"
      >
        Back Home page
      </a>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits} from "vue";
const props = defineProps({
  isVisible: {
    type: Boolean,
    required: true,
  },
  tryAgain: {
    type: String,
    default: 'Retry'
  },
  cancelText: {
    type: String,
    default: 'Back Home page'
  },
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  isError: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['confirm', 'cancel'])

function confirm() {
  window.location.href = '/dashboard';
}

function cancel() {
  emit('cancel')
}
</script>


<style scoped>

.payment-status-modal {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.payment-modal-content {
  background: white;
  padding: 40px;
  border-radius: 16px;
  width: 450px;
  position: relative;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.close-button {
   width: 32px;
   height: 32px;
   padding: 8px;
   position: absolute;
   right: 24px;
   font-size: 35px;
   cursor: pointer;
   color: #aaa;
   border: none;
   background: none;
    left: 986px;
 }
 .close-button:hover {
   color: black;
 }

.icon-container {
  margin: 0 auto 16px;
  width: 64px;
  height: 64px;
}
.status-icon {
  width: 100%;
  height: auto;
}

.modal-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.modal-title.success {
  color: #007828;
}
.modal-title.error {
  color: #B80000;
}

.modal-subtitle {
  color: #1C1C1C;
  margin-bottom: 4px;
}

.modal-desc {
  color: #1C1C1C;
  margin-bottom: 24px;
}

.primary-btn {
  background-color: #0066d4;
  color: white;
  border: none;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 15px;
  border-radius: 6px;
  cursor: pointer;
}
.primary-btn:hover {
  background-color: #005bb5;
}

.link-btn {
  color: #0066d4;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: pointer;
}
.link-btn:hover {
  color: #005bb5;
}
</style>
